// 'use client';

// import React, { useCallback, useEffect, useRef, useState } from 'react';
// import { ChevronDown } from 'lucide-react';

// import { Entity, Snippet, SNIPPET_TYPE } from '@repo/types';
// import { Button } from '@repo/ui/components/ui/button';
// import { cn } from '@repo/ui/lib/utils';

// import { tabs } from './tabs';

// type PartialSNIPPET_TYPE = Pick<
//   typeof SNIPPET_TYPE,
//   'CLAIMEDFACTS' | 'OPINIONSTATEMENTS' | 'DUBIOUSCLAIMS'
// >['CLAIMEDFACTS' | 'OPINIONSTATEMENTS' | 'DUBIOUSCLAIMS'];

// interface AccordionState {
//   isCollapsed: boolean;
//   expandedAccordions: Set<number>;
// }

// const DEFAULT_ACCORDIONS_STATE: AccordionState = {
//   isCollapsed: false,
//   expandedAccordions: new Set(),
// } as const;

// interface TabsComponentProps {
//   snippets: Snippet[];
//   currTab: SNIPPET_TYPE;
//   setCurrTab: (tab: SNIPPET_TYPE) => void;
//   entities?: Entity[];
// }

// export const TabsComponent: React.FC<TabsComponentProps> = ({
//   snippets,
//   currTab,
//   setCurrTab,
//   entities,
// }) => {
//   const [accordionsState, setAccordionsState] = useState<
//     Record<PartialSNIPPET_TYPE, AccordionState>
//   >(() => {
//     const initialState: Record<PartialSNIPPET_TYPE, AccordionState> = {
//       [SNIPPET_TYPE.CLAIMEDFACTS]: { ...DEFAULT_ACCORDIONS_STATE },
//       [SNIPPET_TYPE.OPINIONSTATEMENTS]: { ...DEFAULT_ACCORDIONS_STATE },
//       [SNIPPET_TYPE.DUBIOUSCLAIMS]: { ...DEFAULT_ACCORDIONS_STATE },
//     };

//     // Initialize all accordions as expanded by default
//     Object.keys(initialState).forEach((tabType) => {
//       const tabData = snippets.filter(
//         (snippet) => snippet.type === (tabType as PartialSNIPPET_TYPE),
//       );
//       initialState[tabType as PartialSNIPPET_TYPE].expandedAccordions = new Set(
//         tabData.map((_, index) => index),
//       );
//       initialState[tabType as PartialSNIPPET_TYPE].isCollapsed = false;
//     });

//     return initialState;
//   });

//   const floatingUnderlineRef = useRef<HTMLDivElement>(null);

//   const getTabData = useCallback(
//     (type: PartialSNIPPET_TYPE) =>
//       snippets.filter((snippet) => snippet.type === type),
//     [snippets],
//   );

//   const getCurrentTabState = useCallback(() => {
//     return accordionsState[currTab as PartialSNIPPET_TYPE];
//   }, [accordionsState, currTab]);

//   const updateAccordionState = useCallback(
//     (tabType: SNIPPET_TYPE, index: number, isExpanded: boolean) => {
//       setAccordionsState((prev) => {
//         const newState = { ...prev };
//         const tabState = { ...newState[tabType as PartialSNIPPET_TYPE] };

//         if (isExpanded) {
//           tabState.expandedAccordions.add(index);
//         } else {
//           tabState.expandedAccordions.delete(index);
//         }

//         tabState.isCollapsed = tabState.expandedAccordions.size === 0;

//         newState[tabType as PartialSNIPPET_TYPE] = tabState;
//         return newState;
//       });
//     },
//     [],
//   );

//   const toggleAllAccordions = useCallback(() => {
//     const currentState = getCurrentTabState();
//     const tabData = getTabData(currTab as PartialSNIPPET_TYPE);
//     const allExpanded = currentState.expandedAccordions.size === tabData.length;

//     setAccordionsState((prev) => {
//       const newState = { ...prev };
//       const tabState = { ...newState[currTab as PartialSNIPPET_TYPE] };

//       if (allExpanded) {
//         // Collapse all
//         tabState.expandedAccordions.clear();
//         tabState.isCollapsed = true;
//       } else {
//         // Expand all
//         tabState.expandedAccordions = new Set(tabData.map((_, index) => index));
//         tabState.isCollapsed = false;
//       }

//       newState[currTab as PartialSNIPPET_TYPE] = tabState;
//       return newState;
//     });
//   }, [currTab, getCurrentTabState, getTabData]);

//   const getTabTitleText = useCallback(() => {
//     return tabs.find((tab) => tab.id === currTab)?.title;
//   }, [currTab]);

//   const getButtonText = useCallback(() => {
//     const currentState = getCurrentTabState();
//     const tabData = getTabData(currTab as PartialSNIPPET_TYPE);
//     const allExpanded = currentState.expandedAccordions.size === tabData.length;

//     return allExpanded ? 'Collapse all reasons' : 'Expand all reasons';
//   }, [currTab, getCurrentTabState, getTabData]);

//   const isAtLeastOneAccordionExpanded = useCallback(() => {
//     return Object.values(accordionsState).some(
//       (state) => state.expandedAccordions.size > 0,
//     );
//   }, [accordionsState]);

//   const isAllAccordionsExpanded = useCallback(() => {
//     const currentState = getCurrentTabState();
//     const tabData = getTabData(currTab as PartialSNIPPET_TYPE);
//     const allExpanded = currentState.expandedAccordions.size === tabData.length;

//     return allExpanded;
//   }, [currTab, getCurrentTabState, getTabData]);

//   useEffect(() => {
//     if (currTab) {
//       const hoveredElement = document.getElementById(`${currTab}-inner-tab`);
//       const floatingBarElement = floatingUnderlineRef.current;
//       if (hoveredElement && floatingBarElement) {
//         floatingBarElement.style.width = `${hoveredElement.offsetWidth}px`;
//         floatingBarElement.style.left = `${hoveredElement.offsetLeft}px`;
//       }
//     }
//   }, [currTab]);

//   return (
//     <div className="w-full">
//       <div
//         role="tablist"
//         className="relative grid h-auto gap-[5px] w-full list-none grid-cols-3 rounded-none bg-transparent p-0 shadow-none"
//       >
//         {tabs.map((tab) => (
//           <Button
//             key={tab.id}
//             id={`${tab.id}-inner-tab`}
//             type="button"
//             variant="ghost"
//             role="tab"
//             data-state={currTab === tab.id ? 'active' : 'inactive'}
//             onClick={() => setCurrTab(tab.id as PartialSNIPPET_TYPE)}
//             className="group/tab-trigger flex h-auto w-full items-center gap-2 rounded-md border border-white bg-[#1D2735] px-2 py-[3px] text-[#F0F0F0] shadow-none hover:bg-[#F0F0F0]/40 data-[state=active]:hover:bg-[#F0F0F0] data-[state=active]:bg-[#F0F0F0] data-[state=active]:text-neutral-2 data-[state=active]:shadow-none"
//           >
//             <div className="text-sm font-normal leading-4 group-data-[state=active]/tab-trigger:font-medium @cred-md:text-[15px] @cred-md:leading-[20px] @cred-lg:text-[15px] @cred-lg:leading-[21px] @cred-xl:text-[16.5px] @cred-xl:leading-[23px]">
//               {tab.triggerTitle}
//             </div>
//           </Button>
//         ))}
//       </div>
//       <div className="flex justify-between pt-2.5 pb-0.5">
//         <div className="flex items-center gap-2">
//           <span className="text-sm font-bold leading-4 @cred-md:text-[15px] @cred-md:leading-[20px] @cred-lg:text-[16px] @cred-lg:leading-[21px] @cred-xl:text-[16.5px] @cred-xl:leading-[23px]">
//             {getTabTitleText()}
//           </span>
//         </div>
//         <Button
//           type="button"
//           onClick={toggleAllAccordions}
//           data-active={isAtLeastOneAccordionExpanded()}
//           className="h-auto pl-2.5 pr-1.5 py-px @cred-lg:py-[3px] bg-transparent hover:bg-white rounded-full cursor-pointer flex items-center justify-center gap-0.5 text-white hover:text-black transition-colors border-white border no-underline hover:no-underline text-[11.5px] @cred-md:text-[13.5px] @cred-xl:text-[15.5px] [&[data-active=true]]:text-black [&[data-active=true]]:bg-white"
//         >
//           {getButtonText()}
//           <ChevronDown
//             className={cn(
//               'cursor-pointer size-4 transition-transform @cred-md:size-[18px] @cred-lg:size-5 @cred-xl:size-6',
//               isAllAccordionsExpanded() && 'rotate-180',
//             )}
//           />
//         </Button>
//       </div>
//       {tabs.map((tab) => (
//         <tab.content
//           key={tab.id}
//           id={`${tab.id}-content`}
//           active={currTab === tab.id}
//           entities={entities}
//           data={getTabData(tab.id as PartialSNIPPET_TYPE)}
//           accordionsState={accordionsState[tab.id as PartialSNIPPET_TYPE]}
//           updateAccordionState={updateAccordionState}
//           tabType={tab.id as PartialSNIPPET_TYPE}
//         />
//       ))}
//     </div>
//   );
// };

'use client';

import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';

import { track } from '@repo/analytics';
import { Snippet, SNIPPET_TYPE } from '@repo/types';
import { Button } from '@repo/ui/components/ui/button';
import { cn } from '@repo/ui/lib/utils';

import { tabs } from './tabs';

type PartialSNIPPET_TYPE = Pick<
  typeof SNIPPET_TYPE,
  'CLAIMEDFACTS' | 'OPINIONSTATEMENTS' | 'DUBIOUSCLAIMS'
>['CLAIMEDFACTS' | 'OPINIONSTATEMENTS' | 'DUBIOUSCLAIMS'];

interface AccordionState {
  isCollapsed: boolean;
  expandedAccordions: Set<number>;
}

const DEFAULT_ACCORDIONS_STATE: AccordionState = {
  isCollapsed: false,
  expandedAccordions: new Set(),
} as const;

interface TabsComponentProps {
  snippets: Snippet[];
  currTab: SNIPPET_TYPE;
  setCurrTab: (tab: SNIPPET_TYPE) => void;
  /** Article slug (analytics wire id) for `article_snippet_tab_viewed`. */
  articleId?: string;
}

export const TabsComponent: React.FC<TabsComponentProps> = ({
  snippets,
  currTab,
  setCurrTab,
  articleId,
}) => {
  const [accordionsState, setAccordionsState] = useState<
    Record<PartialSNIPPET_TYPE, AccordionState>
  >(() => {
    const initialState: Record<PartialSNIPPET_TYPE, AccordionState> = {
      [SNIPPET_TYPE.CLAIMEDFACTS]: { ...DEFAULT_ACCORDIONS_STATE },
      [SNIPPET_TYPE.OPINIONSTATEMENTS]: { ...DEFAULT_ACCORDIONS_STATE },
      [SNIPPET_TYPE.DUBIOUSCLAIMS]: { ...DEFAULT_ACCORDIONS_STATE },
    };

    // Initialize all accordions as expanded by default
    Object.keys(initialState).forEach((tabType) => {
      const tabData = snippets.filter(
        (snippet) => snippet.type === (tabType as PartialSNIPPET_TYPE),
      );
      initialState[tabType as PartialSNIPPET_TYPE].expandedAccordions = new Set(
        tabData.map((_, index) => index),
      );
      initialState[tabType as PartialSNIPPET_TYPE].isCollapsed = false;
    });

    return initialState;
  });

  // CRE-XXX (2026-05-20): visible UI label MUST be plain "Claims" — no
  // qualifier. Was 'Dubius' / 'Dubius Claims' which is defamation-adjacent
  // (PR #211 partial fix missed this surface). The toggle below now selects
  // between two identical labels; preserved for layout-stability behavior.
  const [claimsTabLabel, setClaimsTabLabel] = useState('Claims');

  const floatingUnderlineRef = useRef<HTMLDivElement>(null);
  const claimsTabRef = useRef<HTMLButtonElement>(null);

  const getTabData = useCallback(
    (type: PartialSNIPPET_TYPE) =>
      snippets.filter((snippet) => snippet.type === type),
    [snippets],
  );

  const getCurrentTabState = useCallback(() => {
    return accordionsState[currTab as PartialSNIPPET_TYPE];
  }, [accordionsState, currTab]);

  const updateAccordionState = useCallback(
    (tabType: SNIPPET_TYPE, index: number, isExpanded: boolean) => {
      setAccordionsState((prev) => {
        const newState = { ...prev };
        const tabState = { ...newState[tabType as PartialSNIPPET_TYPE] };

        if (isExpanded) {
          tabState.expandedAccordions.add(index);
        } else {
          tabState.expandedAccordions.delete(index);
        }

        tabState.isCollapsed = tabState.expandedAccordions.size === 0;

        newState[tabType as PartialSNIPPET_TYPE] = tabState;
        return newState;
      });
    },
    [],
  );

  const toggleAllAccordions = useCallback(() => {
    const currentState = getCurrentTabState();
    const tabData = getTabData(currTab as PartialSNIPPET_TYPE);
    const allExpanded = currentState.expandedAccordions.size === tabData.length;

    setAccordionsState((prev) => {
      const newState = { ...prev };
      const tabState = { ...newState[currTab as PartialSNIPPET_TYPE] };

      if (allExpanded) {
        // Collapse all
        tabState.expandedAccordions.clear();
        tabState.isCollapsed = true;
      } else {
        // Expand all
        tabState.expandedAccordions = new Set(tabData.map((_, index) => index));
        tabState.isCollapsed = false;
      }

      newState[currTab as PartialSNIPPET_TYPE] = tabState;
      return newState;
    });
  }, [currTab, getCurrentTabState, getTabData]);

  const getButtonText = useCallback(() => {
    const currentState = getCurrentTabState();
    const tabData = getTabData(currTab as PartialSNIPPET_TYPE);
    const allExpanded = currentState.expandedAccordions.size === tabData.length;

    return allExpanded ? 'Collapse all reasons' : 'Expand all reasons';
  }, [currTab, getCurrentTabState, getTabData]);

  const isAtLeastOneAccordionExpanded = useCallback(() => {
    return Object.values(accordionsState).some(
      (state) => state.expandedAccordions.size > 0,
    );
  }, [accordionsState]);

  const isAllAccordionsExpanded = useCallback(() => {
    const currentState = getCurrentTabState();
    const tabData = getTabData(currTab as PartialSNIPPET_TYPE);
    const allExpanded = currentState.expandedAccordions.size === tabData.length;

    return allExpanded;
  }, [currTab, getCurrentTabState, getTabData]);

  useEffect(() => {
    if (currTab) {
      const hoveredElement = document.getElementById(`${currTab}-inner-tab`);
      const floatingBarElement = floatingUnderlineRef.current;
      if (hoveredElement && floatingBarElement) {
        floatingBarElement.style.width = `${hoveredElement.offsetWidth}px`;
        floatingBarElement.style.left = `${hoveredElement.offsetLeft}px`;
      }
    }
  }, [currTab]);

  useEffect(() => {
    const updateClaimsTabLabel = () => {
      if (!claimsTabRef.current) return;

      const tabElement = claimsTabRef.current;
      const availableWidth = tabElement.offsetWidth;

      if (availableWidth === 0) return; // Element not yet rendered

      // Create a temporary element to measure text width
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      if (!context) return;

      // Get computed styles
      const textElement = tabElement.querySelector('div');
      if (!textElement) return;
      const computedStyle = window.getComputedStyle(textElement);

      // Use a fallback font if the computed font is not available
      const fontWeight = computedStyle.fontWeight || 'normal';
      const fontSize = computedStyle.fontSize || '14px';
      const fontFamily = computedStyle.fontFamily || 'system-ui';
      context.font = `${fontWeight} ${fontSize} ${fontFamily}`;

      // CRE-XXX (2026-05-20): both labels now "Claims" (no qualifier) per
      // legal CYA. Measurement preserved in case we later add a qualifier
      // that needs width-based truncation again.
      const fullText = 'Claims';
      const fullTextWidth = context.measureText(fullText).width;

      // Account for padding (px-3 = 12px on each side = 24px total) and gap (gap-2 = 8px)
      const padding = 24;
      const gap = 8;
      const availableTextWidth = availableWidth - padding - gap;

      if (fullTextWidth <= availableTextWidth) {
        setClaimsTabLabel('Claims');
      } else {
        setClaimsTabLabel('Claims');
      }
    };

    // Use a small delay to ensure the element is rendered
    const timeoutId = setTimeout(() => {
      updateClaimsTabLabel();
    }, 0);

    const resizeObserver = new ResizeObserver(() => {
      // Add a small delay to ensure layout is complete
      setTimeout(updateClaimsTabLabel, 0);
    });

    if (claimsTabRef.current) {
      resizeObserver.observe(claimsTabRef.current);
    }

    // Also update on window resize
    const handleResize = () => {
      setTimeout(updateClaimsTabLabel, 0);
    };
    window.addEventListener('resize', handleResize);

    return () => {
      clearTimeout(timeoutId);
      resizeObserver.disconnect();
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="w-full">
      <div
        role="tablist"
        className="relative grid h-auto w-full list-none grid-cols-3 rounded-none border-b border-foreground bg-transparent p-0 shadow-none"
      >
        {tabs.map((tab) => {
          const isClaimsTab = tab.id === SNIPPET_TYPE.DUBIOUSCLAIMS;
          const displayTitle = isClaimsTab ? claimsTabLabel : tab.title;
          const buttonRef = isClaimsTab ? claimsTabRef : undefined;

          return (
            <Button
              key={tab.id}
              ref={buttonRef}
              id={`${tab.id}-inner-tab`}
              type="button"
              variant="ghost"
              role="tab"
              data-state={currTab === tab.id ? 'active' : 'inactive'}
              onClick={() => {
                setCurrTab(tab.id as PartialSNIPPET_TYPE);
                // Typed track() per doctrine §6 — same registered event the
                // iframe fires for this interaction (was the unregistered raw
                // 'select_snippets_tab', a CRE-793 cross-surface split).
                track('article_snippet_tab_viewed', {
                  article_id: articleId ?? '',
                  tab: tab.id,
                });
              }}
              className="group/tab-trigger flex h-auto w-full items-center gap-2 rounded-none bg-transparent px-3 pb-1 pt-1 text-foreground shadow-none hover:bg-transparent data-[state=active]:bg-transparent data-[state=active]:text-foreground data-[state=active]:shadow-none"
            >
              <div className="text-sm font-normal leading-4 group-data-[state=active]/tab-trigger:font-bold @cred-md:text-base @cred-md:leading-[19px] @cred-lg:text-base @cred-lg:leading-[19px] @cred-xl:text-xl @cred-xl:leading-[23px]">
                {displayTitle}
              </div>
            </Button>
          );
        })}
        <div
          ref={floatingUnderlineRef}
          className={cn(
            'absolute -bottom-px h-0.5 transition-[width,left,background-color] duration-300 ease-in-out @cred-md:h-[2.33px]',
            currTab === SNIPPET_TYPE.CLAIMEDFACTS && 'bg-[#00B378]',
            currTab === SNIPPET_TYPE.OPINIONSTATEMENTS && 'bg-[#FFD700]',
            currTab === SNIPPET_TYPE.DUBIOUSCLAIMS && 'bg-[#EA420F]',
          )}
        />
      </div>
      <div className="flex justify-end pt-2.5 pb-0.5 pr-2.5">
        <Button
          type="button"
          onClick={toggleAllAccordions}
          data-active={isAtLeastOneAccordionExpanded()}
          className="h-auto pl-2.5 pr-1.5 py-0.5 @cred-lg:py-[3px] @cred-xl:py-1 bg-transparent hover:bg-white rounded-full cursor-pointer flex items-center justify-center gap-0.5 text-white hover:text-black transition-colors border-white border no-underline hover:no-underline text-[12.5px] @cred-md:text-[13.5px] @cred-xl:text-[15.5px] [&[data-active=true]]:text-black [&[data-active=true]]:bg-white"
        >
          {getButtonText()}
          <ChevronDown
            className={cn(
              'cursor-pointer size-4 transition-transform @cred-md:size-[18px] @cred-lg:size-5 @cred-xl:size-6',
              isAllAccordionsExpanded() && 'rotate-180',
            )}
          />
        </Button>
      </div>
      {tabs.map((tab) => (
        <tab.content
          key={tab.id}
          id={`${tab.id}-content`}
          active={currTab === tab.id}
          data={getTabData(tab.id as PartialSNIPPET_TYPE)}
          accordionsState={accordionsState[tab.id as PartialSNIPPET_TYPE]}
          updateAccordionState={updateAccordionState}
          tabType={tab.id as PartialSNIPPET_TYPE}
        />
      ))}
    </div>
  );
};
